var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"financialclose-technicalsupport-view"}},[_c('QueriesList',{attrs:{"project":_vm.project,"typenot":"functional","data-testid":"financialclose-technicalsupport-querieslist"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }